import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import DataProvider from './redux/store'
import './i18n';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <React.Fragment>
    <DataProvider>
      <App />
    </DataProvider>
  </React.Fragment>
  //</React.StrictMode> 
);

reportWebVitals();
